<div class="pro_inventory" *ngIf="stock <= 5 && stock !=0">
    <p class="active">
        Hurry! almost sold out...
    </p>
    <div class="inventory-scroll nostripes active">
        <span style="width: 95%;"></span>
    </div>
</div>